import * as turf from "@turf/turf";
import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { Layer, Source } from "react-map-gl";
import { useMapRadiusStore } from "../..";
import GeometryService from "../../services/geometryService";

const radiusLayerId = "radiusLayer";

function RadiusMapLayer() {
    const mapRadiusStore = useMapRadiusStore();
    const geometryService = useMemo(() => new GeometryService(), []);
    const feature = useMemo(() => computed(() => {
        if (!mapRadiusStore.coordinates)
            return undefined;

        const shape = geometryService.mapPolygonToShape(turf.circle([mapRadiusStore.coordinates.longitude, mapRadiusStore.coordinates.latitude], mapRadiusStore.radius, { units: 'miles' }).geometry);
        return geometryService.mapIShapesToPolygonFeatures([shape])[0];
    }), []).get();

    const radiusPolygonGeoJson: any = useMemo(() => ({
        type: "FeatureCollection",
        features: feature ? [feature] : [],
    }), [feature]);

    if (!mapRadiusStore.coordinates)
        return null;

    return (
        <Source id="radiusSource" type="geojson" data={radiusPolygonGeoJson}>
            <Layer
                id={radiusLayerId}
                type={"line"}
                filter={["==", "$type", "Polygon"]}
                layout={{
                    "line-cap": "butt",
                    "line-join": "bevel",
                }}
                paint={{
                    "line-color": "#1E90FF",
                    "line-dasharray": [1, 2],
                    "line-width": 4,
                }}
            />
        </Source>
    );
}

export default observer(RadiusMapLayer);